<template>
  <div>
    <base-title title="Edit Account Petty Cash"
      subtitle="Please fill in the account patty cash information in the form below" />
    <v-form ref="form_data" v-model="form_valid" lazy-validation>
      <v-row class="mx-1 mt-2">
        <base-column :lg="4" :md="4" :sm="12">
          <v-select label="Group Patty Cash" :items="group_patty_cash" v-model="form_data.group_petty_cash_id"
            item-text="name" item-value="id" :rules="rule_group_patty_cash" outlined dense></v-select>
        </base-column>
        <base-column :lg="4" :md="4" :sm="12">
          <v-text-field label="Name" v-model="form_data.name" :rules="rule_name" outlined dense></v-text-field>
        </base-column>
        <base-column :lg="4" :md="4" :sm="12">
          <v-textarea label="Description" rows="2" v-model="form_data.description" outlined dense></v-textarea>
        </base-column>
      </v-row>
      <v-row>
        <v-container>
          <back-button />
          <v-btn color="primary" small class="ma-1" @click.stop="update" :loading="btnLoading"
            :disabled="!form_valid || btnLoading">Update <v-icon right>mdi-content-save</v-icon></v-btn>
        </v-container>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BackButton from "@/components/base/BackButton.vue";
import BaseTitle from "@/components/base/BaseTitle.vue";
import BaseColumn from "@/components/base/BaseColumn.vue";
export default {
  components: { BaseTitle, BaseColumn, BackButton },
  name: "AccountPettyCashEdit",
  data() {
    return {
      btnLoading: false,
      form_valid: true,
      group_patty_cash: [],
      branch: [],
      form_data: {
        group_petty_cash_id: "",
        name: "",
        description: "",
      },
    };
  },

  created() {
    this.findOne();
    this.getBranch();
    this.getGroupPattyCash();
  },

  methods: {
    update: async function () {
      if (this.$refs.form_data.validate()) {
        this.btnLoading = true;
        await this.$axios
          .post(
            "/transaction/petty-cash-categories/" + this.$route.params.id,
            {
              _method: "PUT",
              group_petty_cash_id: this.form_data.group_petty_cash_id,
              name: this.form_data.name,
              description: this.form_data.description,
            },
            {
              headers: {
                Authorization: this.$store.getters["auth/Token"],
              },
            }
          )
          .then(() => {
            this.btnLoading = false;
            this.$router.push({ name: "account-petty-cash.index" });
          })
          .catch(() => {
            this.btnLoading = false;
          });
      }
    },

    async getBranch() {
      await this.$axios("/master/branches?active=1", {
        headers: {
          Authorization: this.$store.getters["auth/Token"],
        },
      }).then(({ data }) => {
        this.branch = data.branch.data;
      });
    },

    async getGroupPattyCash() {
      await this.$axios("/master/group-petty-cashes", {
        headers: {
          Authorization: this.$store.getters["auth/Token"],
        },
      }).then(({ data }) => {
        this.group_patty_cash = data.group_petty_cashes.data;
      });
    },


    findOne() {
      this.$axios
        .get("/transaction/petty-cash-categories/" + this.$route.params.id, {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.form_data.group_petty_cash_id = data.resource.group_petty_cash_id;
          this.form_data.name = data.resource.name;
          this.form_data.description = data.resource.description;
        })
        .catch(() => {
          this.$router.push({ name: "account-petty-cash.index" });
        });
    },
  },

  computed: {
    ...mapGetters("auth", {
      ROLE: "Role",
    }),
  },
};
</script>